import React from "react";
import { NavLink, useHistory } from "react-router-dom";

import { ReactComponent as DeleteIcon } from "../../../assets/icons/delete.svg";
import { ReactComponent as ConsoleIcon } from "../../../assets/icons/console.svg";
import { ReactComponent as PowerIcon } from "../../../assets/icons/power.svg";
import { ReactComponent as ArrowDownIcon } from "../../../assets/icons/arrow_down.svg";

import ActionButton from "../../../components/Buttons/ActionButton";
import DeviceMenu from "../Shared/DeviceMenu";

type DeviceProp = {
  device: any;
};

const StereoCamera = (props: DeviceProp) => {
  const type = props.device;
  const history = useHistory();
  history.push(`/devices/${type.id}/general`);

  return (
    <div className="device-main main-content">
      <div>
        <div className="header">
          <NavLink to="/devices" className="device-actions">
            <ArrowDownIcon />
          </NavLink>
          <h3 className="title">{props.device.name}</h3>
          <div className="list-item-actions main">
            <ActionButton
              icon={<PowerIcon />}
              className={`list-item-action ${props.device.Status && "online"}`}
            />
            <NavLink to={`/devices/${props.device.id}/logs`}>
              <ActionButton icon={<ConsoleIcon />} className="list-item-action logs-action" />
            </NavLink>
            <ActionButton icon={<DeleteIcon />} className="list-item-action" />
          </div>
        </div>
      </div>
      <DeviceMenu typeId={type.deviceTypes.id} />
    </div>
  );
};

export default StereoCamera;
